import ArrayHelper from '../../helpers/ArrayHelper.js';
import ObjectHelper from '../../helpers/ObjectHelper.js';
import Unstructured from './Unstructured.js';
import DataHelper from '../../helpers/DataHelper.js';

export default class SearchResults extends Unstructured {
  setData(
    vehicles,
    vehiclesCountPerGroup,
    vehiclesCountPerFranchise,
    vehiclesCountPerLocation,
    vehicleOfferIds,
  ) {
    this._pushEventData({
      vr_gr: vehiclesCountPerGroup ? ObjectHelper.parseToObject(vehiclesCountPerGroup) : null,
      vr_fr: vehiclesCountPerFranchise ? ObjectHelper.parseToObject(vehiclesCountPerFranchise) : null,
      vr_lo: vehiclesCountPerLocation ? ObjectHelper.parseToObject(vehiclesCountPerLocation) : null,
      vr_ve: ArrayHelper.mapToNumbers(vehicles),
      vr_vo: this._mapVehicleOfferIdsToArrayOfStrings(vehicleOfferIds)
    });
  }

  _pushEventData(data) {
    super._pushEventData({
      schema: 'iglu:uk.co.netdirector.snowplow/vehicle_results_unstructured_event/jsonschema/2-0-2',
      data: DataHelper.filterDeeply(data)
    });
  }

  _mapVehicleOfferIdsToArrayOfStrings(vehicleOfferIds) {
    if (typeof vehicleOfferIds === 'number' || typeof vehicleOfferIds === 'string') {
      return ArrayHelper.mapToStrings([vehicleOfferIds]);
    }
    if (Array.isArray(vehicleOfferIds)) {
      return ArrayHelper.mapToStrings(vehicleOfferIds)
    }
    return null;
  }
}
